import router from '@/router'
import { fetchHealth } from '@/services/healthApi'

const POLL_INTERVAL_MS = 30000

let pollTimer = null

export const health = {
  namespaced: true,
  state: {
    available: true,
    redirectFrom: null,
  },
  mutations: {
    SET_AVAILABLE(state, value) {
      state.available = value
    },
    SET_REDIRECT_FROM(state, path) {
      state.redirectFrom = path
    },
  },
  actions: {
    startMonitoring({ dispatch }) {
      if (pollTimer) return
      dispatch('checkHealth')
      pollTimer = setInterval(() => dispatch('checkHealth'), POLL_INTERVAL_MS)
    },
    async checkHealth({ state, commit }) {
      const onServiceUnavailablePage = router.currentRoute.name === 'service_unavailable'
      try {
        await fetchHealth()
        if (!state.available) {
          commit('SET_AVAILABLE', true)
          if (onServiceUnavailablePage) {
            router.push(state.redirectFrom || '/').catch(() => {})
          }
        }
      } catch {
        if (state.available) {
          commit('SET_AVAILABLE', false)
        }
        if (!onServiceUnavailablePage) {
          commit('SET_REDIRECT_FROM', router.currentRoute.fullPath)
          router.push({ name: 'service_unavailable' }).catch(() => {})
        }
      }
    },
  },
}
